function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export const formatTitle = (
  title: string,
  replace?: Record<string, string>,
  capitalizeAll: boolean = true
): string => {
  if (replace && replace[title]) return replace[title];

  if (!title) return "";

  const str = title.replace(/_/g, " ");
  if (capitalizeAll)
    return str.replace(/\b\w/g, (letter) => letter.toUpperCase());
  return capitalizeFirstLetter(str);
};

export const formatTitleFirstWord = (title: string): string => {
  const str = title.replace(/_/g, " ");
  return capitalizeFirstLetter(str);
};
